import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Card, CardContent, CircularProgress, Button } from '@mui/material';
import { fetchNotes } from '../../redux/notesRelated/notesSlice';

const StudentNotes = () => {
    const dispatch = useDispatch();
    const { currentUser } = useSelector(state => state.user);
    const { notes, loading, error } = useSelector(state => state.notes);

    useEffect(() => {
        if (currentUser) {
            dispatch(fetchNotes(currentUser._id));
        }
    }, [dispatch, currentUser]);

    return (
        <Box sx={styles.container}>
            <Typography variant="h4" sx={styles.title}>
                Received Notes
            </Typography>

            {loading && <CircularProgress sx={styles.loader} />}
            
            {error && (
                <Typography color="error" sx={styles.error}>
                    Error: {error}
                </Typography>
            )}

            {notes.length === 0 && !loading && !error && (
                <Typography sx={styles.noNotes}>No notes available</Typography>
            )}

            {notes.map((note) => (
                <Card key={note._id} sx={styles.noteCard}>
                    <CardContent>
                        <Typography variant="h6" sx={styles.noteTitle}>
                            {note.title}
                        </Typography>
                        <Typography variant="body2" sx={styles.noteMeta}>
                            From: {note.teacherId.name} • {new Date(note.date).toLocaleDateString()}
                        </Typography>
                        <Typography variant="body1" sx={styles.noteContent}>
                            {note.content}
                        </Typography>
                        <Button variant="contained" sx={styles.button}>View Details</Button>
                    </CardContent>
                </Card>
            ))}
        </Box>
    );
};

const styles = {
    container: {
        maxWidth: 800,
        mx: 'auto',
        p: 3,
        backgroundColor: '#F4F7F5',
        minHeight: '100vh',
    },
    title: {
        mb: 3,
        fontWeight: 'bold',
        color: '#008080',
        textAlign: 'center',
    },
    loader: {
        display: 'block',
        mx: 'auto',
        my: 2,
        color: '#FFD700',
    },
    error: {
        textAlign: 'center',
        my: 2,
        color: '#D32F2F',
    },
    noNotes: {
        textAlign: 'center',
        my: 3,
        color: 'text.secondary',
    },
    noteCard: {
        mb: 2,
        boxShadow: '0px 4px 12px rgba(0, 128, 128, 0.2)',
        borderLeft: '5px solid #FFD700',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
            transform: 'scale(1.02)',
        },
    },
    noteTitle: {
        fontWeight: 'bold',
        mb: 1,
        color: '#008080',
    },
    noteMeta: {
        mb: 1,
        fontSize: '0.875rem',
        color: '#555',
    },
    noteContent: {
        whiteSpace: 'pre-wrap',
        color: '#333',
    },
    button: {
        mt: 2,
        backgroundColor: '#008080',
        color: '#FFF',
        '&:hover': {
            backgroundColor: '#006666',
        },
        width: '100%',
        textTransform: 'none',
    },
};

export default StudentNotes;
